import { defer, Observable, startWith } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { api, priorityTraversalApi } from '@ardoq/api';
import type { APIPriorityTraversal, ArdoqId } from '@ardoq/api-types';
import { toPriorityViewpointIds } from './defaultOverview';

export const priorityTraversals$: Observable<APIPriorityTraversal[]> = defer(
  priorityTraversalApi.fetchPriorityTraversals
).pipe(
  tap(response => api.logErrorIfNeeded(response)),
  map(response =>
    api.defaultValueIfError<APIPriorityTraversal[]>(response, [])
  ),
  startWith([])
);

export const priorityViewpointIds$: Observable<ArdoqId[]> =
  priorityTraversals$.pipe(map(toPriorityViewpointIds));
